import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const LegalPage = () => {
  const [activeTab, setActiveTab] = useState("terms");

  // Asegura que el usuario comience desde arriba al entrar
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-blue-100">
      {/* Header Estilizado */}
      <header className="py-12 bg-white border-b border-slate-200 shadow-sm">
        <div className="max-w-4xl mx-auto px-6">
          <Link
            to="/"
            className="flex items-center gap-3 mb-8 group transition-all"
          >
            <div className="bg-gradient-to-br from-blue-500 to-indigo-600 p-2 rounded-lg shadow-blue-200 shadow-lg group-hover:scale-105 transition-transform">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                />
              </svg>
            </div>
            <div className="flex flex-col leading-none">
              <span className="text-2xl font-extrabold tracking-tight bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
                Panamá<span className="text-blue-600">BR</span>
              </span>
              <span className="text-[12px] font-bold text-blue-600 mt-0.5 tracking-tighter">
                by MIVX
              </span>
            </div>
          </Link>

          <h1 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight">
            Centro{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
              Legal
            </span>
          </h1>
          <div className="flex items-center gap-2 mt-4 text-slate-500 font-medium">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
            <p className="text-sm">Última actualización: Marzo 2026</p>
          </div>
        </div>
      </header>

      {/* Navegación de Tabs - Sticky */}
      <div className="sticky top-0 bg-white/80 backdrop-blur-md z-10 border-b border-slate-200 shadow-sm">
        <div className="max-w-4xl mx-auto px-6 flex gap-8">
          {[
            { id: "terms", label: "Términos y Condiciones" },
            { id: "privacy", label: "Política de Privacidad" },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-5 text-sm font-bold transition-all relative ${
                activeTab === tab.id
                  ? "text-blue-600"
                  : "text-slate-400 hover:text-slate-600"
              }`}
            >
              {tab.label}
              {activeTab === tab.id && (
                <div className="absolute bottom-0 left-0 w-full h-1 bg-blue-600 rounded-t-full shadow-[0_-2px_10px_rgba(37,99,235,0.3)]"></div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Contenido Dinámico */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="bg-white border border-slate-200 rounded-3xl shadow-xl shadow-slate-200/60 overflow-hidden transition-all duration-500">
          <article className="p-8 md:p-12 prose prose-slate prose-blue max-w-none">
            {activeTab === "terms" ? (
              <div className="space-y-10 animate-in fade-in slide-in-from-bottom-4 duration-500">
                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    1
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Aceptación de los Términos
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Al acceder o utilizar la plataforma PanamaBR by MIVX, el
                    usuario acepta cumplir con los presentes Términos y
                    Condiciones. Si el usuario no está de acuerdo con estos
                    términos, deberá abstenerse de utilizar la plataforma.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    2
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Descripción del Servicio
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX es una plataforma educativa digital que
                    ofrece herramientas de estudio, cuestionarios, simuladores y
                    contenidos informativos destinados a apoyar la preparación
                    de los aspirantes al examen de corredor de bienes raíces en
                    la República de Panamá.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    3
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Uso Permitido de la Plataforma
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    El usuario se compromete a utilizar la plataforma
                    exclusivamente con fines educativos y personales. Queda
                    prohibido utilizar el servicio para actividades ilegales,
                    fraudulentas, o que puedan afectar el funcionamiento del
                    sistema o los derechos de otros usuarios.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    4
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Registro de Cuenta
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium italic border-l-4 border-indigo-100 pl-4">
                    Para utilizar ciertas funcionalidades de la plataforma, el
                    usuario deberá crear una cuenta proporcionando información
                    veraz y actualizada. El usuario es responsable de mantener
                    la confidencialidad de sus credenciales de acceso.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    5
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Propiedad Intelectual
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Todos los contenidos disponibles en la plataforma,
                    incluyendo textos, bases de preguntas, simuladores, diseño,
                    software y material educativo, son propiedad de PanamaBR by
                    MIVX o de sus respectivos titulares y están protegidos por
                    las leyes de propiedad intelectual aplicables. Queda
                    prohibida su reproducción, distribución o uso comercial sin
                    autorización previa.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    6
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Precios y Facturación
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    El acceso total a la plataforma tiene un costo de{" "}
                    <strong>$14.99 USD mensuales</strong> (o el precio vigente
                    indicado en la landing page). Al suscribirse, el usuario
                    autoriza el cargo automático mensual. PanamaBR by MIVX se
                    reserva el derecho de ajustar los precios, notificando
                    cualquier cambio con antelación a través del correo
                    electrónico registrado.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    7
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    No Garantía de Aprobación del Examen
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX proporciona herramientas de estudio con
                    fines educativos. El uso de esta plataforma no garantiza la
                    aprobación del examen oficial de corredor de bienes raíces
                    ni la obtención de una licencia profesional. El resultado
                    del examen depende exclusivamente del desempeño individual
                    del usuario.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    8
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Limitación de Responsabilidad
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX no será responsable por daños directos,
                    indirectos, incidentales o consecuenciales derivados del uso
                    o la imposibilidad de uso de la plataforma. El usuario
                    acepta que utiliza el servicio bajo su propio riesgo.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    9
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Suspensión o Terminación de Cuentas
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX se reserva el derecho de suspender o
                    cancelar cuentas de usuarios que violen estos términos,
                    utilicen la plataforma de forma fraudulenta o intenten
                    acceder de forma no autorizada a los sistemas.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    10
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Modificaciones del Servicio
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX podrá modificar o actualizar las
                    funcionalidades de la plataforma en cualquier momento con el
                    objetivo de mejorar el servicio ofrecido.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    11
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Aviso Legal y Fuentes de Información
                  </h2>

                  <p className="leading-relaxed text-slate-600 font-medium mb-4">
                    Este sitio web ha sido desarrollado utilizando información
                    pública disponible del Ministerio de Comercio e Industrias
                    de la República de Panamá (MICI), específicamente del
                    documento oficial
                    <strong> Temario Junta Técnica de Bienes Raíces.</strong>
                  </p>

                  <p className="leading-relaxed text-slate-600 font-medium mb-4">
                    PanamaBR by MIVX no está afiliado, asociado ni representa
                    oficialmente al Ministerio de Comercio e Industrias, a la
                    Junta Técnica de Bienes Raíces ni a la Asociación Panameña
                    de Bienes Raíces.
                  </p>

                  <p className="leading-relaxed text-slate-600 font-medium italic border-l-4 border-indigo-100 pl-4 mb-4">
                    El contenido disponible en esta plataforma tiene únicamente
                    fines educativos e informativos y no reemplaza los cursos
                    oficiales requeridos para obtener la licencia de corredor de
                    bienes raíces.
                  </p>

                  <p className="leading-relaxed text-slate-600 font-medium">
                    La información se proporciona "tal cual" y PanamaBR by MIVX
                    no garantiza su exactitud, integridad o actualización. Para
                    obtener información oficial se recomienda consultar
                    directamente al Ministerio de Comercio e Industrias o a la
                    Asociación Panameña de Bienes Raíces.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-red-50 text-red-600 font-bold text-sm mb-4">
                    12
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Política de Cancelación y Reembolso
                  </h2>
                  <div className="space-y-4 text-slate-600 font-medium">
                    <p className="leading-relaxed">
                      <strong>Cancelación:</strong> El usuario puede cancelar su
                      suscripción en cualquier momento desde su panel de
                      configuración.
                      <span className="text-red-600 font-bold">
                        {" "}
                        Importante:
                      </span>{" "}
                      Al confirmar la cancelación, el acceso a las funciones
                      premium de la plataforma se perderá de manera{" "}
                      <strong>inmediata</strong>, independientemente de los días
                      restantes en el periodo de facturación actual.
                    </p>
                    <p className="leading-relaxed border-l-4 border-red-100 pl-4 italic">
                      <strong>No Reembolso:</strong> Debido a la naturaleza
                      digital del contenido y el acceso instantáneo a la base de
                      datos de preguntas y simuladores,{" "}
                      <strong>
                        no se realizarán reembolsos totales ni parciales
                      </strong>{" "}
                      bajo ninguna circunstancia una vez procesado el pago.
                    </p>
                  </div>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    13
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Legislación Aplicable
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Estos términos se rigen por las leyes de la República de
                    Panamá. Cualquier controversia relacionada con el uso de la
                    plataforma será resuelta conforme a la legislación panameña
                    vigente.
                  </p>
                </section>
              </div>
            ) : (
              <div className="space-y-10 animate-in fade-in slide-in-from-bottom-4 duration-500">
                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    1
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Introducción
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX es una plataforma educativa diseñada para
                    ayudar a los usuarios a prepararse para el examen de
                    corredor de bienes raíces en la República de Panamá. Esta
                    política explica cómo recopilamos, utilizamos y protegemos
                    la información personal de nuestros usuarios conforme a la
                    Ley 81 de 2019 sobre protección de datos personales.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    2
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Responsable del Tratamiento
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX es responsable del tratamiento de los datos
                    personales proporcionados por los usuarios. Nos
                    comprometemos a garantizar la confidencialidad, seguridad y
                    uso adecuado de la información recopilada dentro de nuestra
                    plataforma educativa.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    3
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Datos que Recopilamos
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Recopilamos únicamente la información necesaria para el
                    funcionamiento de la plataforma, incluyendo nombre, correo
                    electrónico, progreso de estudio, resultados de
                    cuestionarios y datos técnicos como dirección IP o tipo de
                    dispositivo utilizado para acceder al servicio.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    4
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Uso de la Información
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium border-l-4 border-indigo-100 pl-4">
                    Utilizamos la información recopilada para gestionar las
                    cuentas de usuario, mostrar el progreso de estudio, mejorar
                    la experiencia educativa, ofrecer soporte técnico y
                    optimizar el funcionamiento de la plataforma.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    5
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Seguridad de los Datos
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Implementamos medidas técnicas y organizativas para proteger
                    la información personal de nuestros usuarios contra accesos
                    no autorizados, pérdidas o alteraciones. Nuestra plataforma
                    utiliza protocolos de seguridad modernos para garantizar la
                    protección de los datos.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    6
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Compartición de Información
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX no vende ni comercializa la información
                    personal de los usuarios. Los datos únicamente podrán ser
                    compartidos cuando sea necesario para cumplir con
                    obligaciones legales o para el funcionamiento técnico de la
                    plataforma mediante proveedores de servicios tecnológicos.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    7
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Derechos del Usuario
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Los usuarios tienen derecho a acceder, rectificar,
                    actualizar o solicitar la eliminación de sus datos
                    personales. También pueden revocar el consentimiento
                    otorgado para el tratamiento de sus datos en cualquier
                    momento contactando a nuestro equipo de soporte.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    8
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Conservación de los Datos
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Conservamos los datos personales únicamente durante el
                    tiempo necesario para cumplir con las finalidades educativas
                    de la plataforma o con las obligaciones legales aplicables
                    en la República de Panamá.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    9
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Uso de Cookies
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    Nuestra plataforma puede utilizar cookies o tecnologías
                    similares para mejorar la experiencia de navegación,
                    recordar preferencias del usuario y analizar el uso de los
                    servicios ofrecidos.
                  </p>
                </section>

                <section>
                  <div className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 font-bold text-sm mb-4">
                    10
                  </div>
                  <h2 className="text-2xl font-black text-slate-900 mb-4 mt-0">
                    Cambios en la Política
                  </h2>
                  <p className="leading-relaxed text-slate-600 font-medium">
                    PanamaBR by MIVX se reserva el derecho de modificar esta
                    política de privacidad en cualquier momento. Las
                    actualizaciones serán publicadas en la plataforma y entrarán
                    en vigor desde el momento de su publicación.
                  </p>
                </section>
              </div>
            )}
          </article>
        </div>

        {/* Footer de Página Legal */}
        <div className="mt-16 flex flex-col items-center gap-6">
          <Link
            to="/"
            className="flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-full font-bold hover:bg-blue-600 transition-all shadow-lg hover:shadow-blue-200 active:scale-95"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Volver al Inicio
          </Link>
          <p className="text-slate-400 text-sm font-medium">© 2026 PanamaBR.</p>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
